import ApiService from "@/services/ApiService";

class CrmService {
  getFeePot() {
    return new Promise((resolve) => {
      return ApiService.get("/bill/v2/fee-pots").then(
        response => {
          if (response?.data?.availableAmount === 0) {
            resolve(null);
            return;
          }
          resolve(response.data);
        },
        error => {
          //TODO check status?
          console.log("User without fee pot", error);
          resolve(null);
        }
      );
    });

  }

}

export default new CrmService();
